<div class="mb-m onboarding-step-container">
	<slot name="top" />

	<slot name="text" />
	<div class="main-modes-container">
		<div class="inner-modes-container">
			<slot name="left" />
		</div>
		<div class="inner-modes-container">
			<slot name="right" />
		</div>
	</div>
</div>

<style>
	.onboarding-step-container {
		border: 1px solid #5b5f66;
		border-radius: 12px;
		padding: 24px;
	}

	.main-modes-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.inner-modes-container {
		width: 50%;
	}

	@media (max-width: 639.98px) {
		.main-modes-container {
			flex-direction: column-reverse;
		}

		.inner-modes-container {
			width: 100%;
		}
	}
</style>
